var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeEditorAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_3333_30816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 8C16 3.58333 12.4167 0 8 0C3.58333 0 0 3.58333 0 8C0 12.4167 3.58333 16 8 16C12.4167 16 16 12.4167 16 8Z",
    fill: "#E7D6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.19961 4.8002L3.99961 8.0002L7.19961 11.2002L6.39961 12.8002L1.59961 8.0002L6.39961 3.2002L7.19961 4.8002ZM8.79961 11.2002L11.9996 8.0002L8.79961 4.8002L9.59961 3.2002L14.3996 8.0002L9.59961 12.8002L8.79961 11.2002Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3333_30816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeEditorAction);
export default __webpack_public_path__ + "static/media/CodeEditorAction.ef539661b6540ef7233902ec064fb836.svg";
export { ForwardRef as ReactComponent };